import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Notificaations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentdata: {},
      librarydata: {},
      staffdata: {},
      schooldata: {},
      schoolinfo: {},
      suppliersdata: {},
      staffbasicsalarycount: "",
      studentamountpaid: "",
      studenttotalfee: "",
      totalsalary: "",
      todaycollectedfee: "",
      lastweekcollectedfee: "",
      lastmonthcollectedfee: "",
      halfyearlycollectedfee: "",
      yearlycollectedfee: "",
      totalcomplaint: "",
      todaybirthday: "",
      upcomingexam: "",
      upcomingevent: "",
      upcomingholiday: "",
      loading: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetch({
      school: this.props.user.school,
      session: this.props.user.session.id,
    });
    this.fetchstaff({ school: this.props.user.school });
    this.fetchschoolcount({ school: this.props.user.school });
    this.fetchsupplierscount({ school: this.props.user.school });
    this.fetchcollectedfee({ school: this.props.user.school });
    // this.fetchactivitycount();
    // this.fetchtodaybirthday({
    //   school: this.props.user.school,
    //   session: this.props.user.session.id,
    // });
    // this.fetchupcomingevent({ school: this.props.user.school });
    // this.fetchupcomingholiday({ school: this.props.user.school });
    // this.fetchupcomingexam({ school: this.props.user.school });
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios.get(`/api/studentcount`, { params: { ...params } }).then((res) => {
      this.setState({ studentdata: res.data, loading: false });
    });
  };
  fetchsupplierscount = (params = {}) => {
    axios.get(`/api/supplierscount`, { params: { ...params } }).then((res) => {
      this.setState({ suppliersdata: res.data });
    });
  };

  fetchtotalsalary = (params = {}) => {
    axios.get(`/api/payrollcount`, { params: { ...params } }).then((res) => {
      this.setState({ totalsalary: res.data.total_salary.total_salary__sum });
    });
  };

  fetchstaff = (params = {}) => {
    axios.get(`/api/staffcount`, { params: { ...params } }).then((res) => {
      this.setState({ staffdata: res.data });
    });
  };

  fetchschoolcount = (params = {}) => {
    axios.get(`/api/schoolcount`, { params: { ...params } }).then((res) => {
      this.setState({ schooldata: res.data });
    });
  };

  fetchcollectedfee = (params = {}) => {
    axios
      .get(`/api/collectedfee?school=${this.props.user.school}`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          todaycollectedfee: res.data.today_collected_fee.amount_paid__sum,
          lastweekcollectedfee: res.data.week_collected_fee.amount_paid__sum,
          lastmonthcollectedfee:
            res.data.currentmonth_collected_fee.amount_paid__sum,
          halfyearlycollectedfee:
            res.data.sixmonth_collected_fee.amount_paid__sum,
          yearlycollectedfee: res.data.year_collected_fee.amount_paid__sum,
        });
      });
  };

  fetchactivitycount = (params = {}) => {
    axios
      .get(`/api/todayactivitycount`, { params: { ...params } })
      .then((res) => {
        this.setState({ totalcomplaint: res.data });
      });
  };
  fetchtodaybirthday = (params = {}) => {
    axios
      .get(`/api/todaybirthdaycount`, { params: { ...params } })
      .then((res) => {
        this.setState({ todaybirthday: res.data.birthday_count });
      });
  };
  fetchupcomingexam = (params = {}) => {
    axios
      .get(`/api/upcomingexam?limit=1`, { params: { ...params } })
      .then((res) => {
        if (res.data.results.length > 0) {
          this.setState({
            upcomingexam: res.data.results[0].exam_type,
          });
        }
      });
  };
  fetchupcomingevent = (params = {}) => {
    axios
      .get(`/api/upcomingevents?limit=1&ordering=from_date`, {
        params: { ...params },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          this.setState({ upcomingevent: res.data.results[0].event_name });
        }
      });
  };
  fetchupcomingholiday = (params = {}) => {
    axios
      .get(`/api/upcomingholidays?limit=1&ordering=from_date`, {
        params: { ...params },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          this.setState({
            upcomingholiday: res.data.results[0].holidays_name,
          });
        }
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      loading,
      studentdata,
      staffdata,
      schooldata,
      schoolinfo,
      suppliersdata,
      studentamountpaid,
      studenttotalfee,
      todaycollectedfee,
      lastweekcollectedfee,
      lastmonthcollectedfee,
      halfyearlycollectedfee,
      yearlycollectedfee,
      totalcomplaint,
      todaybirthday,
      upcomingexam,
      upcomingevent,
      upcomingholiday,
    } = this.state;

    const dataIncome = [
      {
        name: "Total Student",
        expence: `${Number(studentdata.student_count)}`,
      },
      {
        name: "Total Staff",
        expence: `${Number(staffdata.staff_count)}`,
      },
    ];

    const dataExpense = [
      {
        name: "Today Collected Fee",
        expence: `${Number(todaycollectedfee)}`,
      },
      {
        name: "Last 7 days Collected Fee",
        expence: `${Number(lastweekcollectedfee)}`,
      },
      {
        name: "Current Month Collected Fee",
        expence: `${Number(lastmonthcollectedfee)}`,
      },
      {
        name: "Last 6 Months Collected Fee",
        expence: `${Number(halfyearlycollectedfee)}`,
      },
      {
        name: "Current Year Collected Fee",
        expence: `${Number(yearlycollectedfee)}`,
      },
    ];

    const dataBalance = [
      {
        name: "Upcoming Holiday",
        expence: `${Number(upcomingholiday)}`,
      },
      {
        name: "Upcoming Events",
        expence: `${Number(upcomingevent)}`,
      },
      {
        name: "Upcoming Exam",
        expence: `${Number(upcomingexam)}`,
      },
      {
        name: "Today's Birthday",
        expence: `${Number(todaybirthday)}`,
      },
      {
        name: "Today's Complaint",
        expence: `${Number(totalcomplaint)}`,
      },
    ];

    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header to="/home" title="Dashboard" />
        <div className="container my-3 col-12">
          <>
            <div className="th-15 th-bold text-primary mb-1">Stats</div>
            <div className="d-flex  flex-wrap">
              {dataIncome?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 text-primary">
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="th-15 th-bold th-primary mb-1 mt-4">
              Collected Fee
            </div>
            <div className="d-flex  flex-wrap">
              {dataExpense?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 text-primary">
                            <span className="th-roboto">₹</span>
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/*<div className="th-12 th-medium text-success mb-1 mt-4">
              Upcomings
            </div>
            <div className="d-flex  flex-wrap">
              {dataBalance?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 text-primary">
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>*/}
          </>
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(Notificaations);
